import { useEffect, useState } from 'react';

import { eucdmCodes } from '../components/EucdmCode/eucdmCodes';
import { useSettings } from './useSettings';

export const useEucdmCodes = () => {
  const { data: settings } = useSettings();

  const [showEucdmNumbers, setShowEucdmNumbers] = useState(localStorage.getItem('showEucdmNumbers') === 'true');

  const handleStorageChange = (e: CustomEvent) => {
    const key = e?.detail?.key;

    if (key === 'showEucdmNumbers') {
      const newValue = e.detail.newValue;
      setShowEucdmNumbers(newValue === 'true');
    }
  };

  useEffect(() => {
    window.addEventListener('localStorageChange', handleStorageChange as EventListener);
  }, []);

  const toggleEucdmDisplay = () => {
    const newValue = !showEucdmNumbers;
    setShowEucdmNumbers(newValue);
    localStorage.setItem('showEucdmNumbers', newValue.toString());

    window.dispatchEvent(
      new CustomEvent('localStorageChange', {
        detail: { key: 'showEucdmNumbers', newValue: newValue.toString() },
      }),
    );
  };

  const getCode = (path: string): string | null => {
    if (!showEucdmNumbers || !eucdmCodes[path]) return null;

    const rawCode = eucdmCodes[path];

    if (typeof rawCode === 'string') return rawCode;

    if (typeof rawCode === 'object' && rawCode !== null) {
      return rawCode[settings.country] || null;
    }

    return null;
  };

  return {
    getCode,
    showEucdmNumbers,
    toggleEucdmDisplay,
  };
};
